import Tab from './Tab';
import TabPanel from './TabPanel';
Tab.TabPanel = TabPanel;

export default Tab;
